import {Injectable, TemplateRef} from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SidenavService {
  public readonly isOpenSideBar = new BehaviorSubject<boolean>(false);
  readonly isOpenSideBar$ = this.isOpenSideBar.asObservable();
  template = null as TemplateRef<any> | null;

  constructor() { }

  public open(template: TemplateRef<any>) {
    this.template = template;
  }

  public close() {
    this.template = null;
  }
}
